var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.42,407.4c83.78,43.77,219.62,43.77,303.41,0s83.78-114.73,0-158.5-219.63-43.78-303.42,0S22.63,363.63,106.42,407.4Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.23,
    cy: 400.82,
    rx: 30.67,
    ry: 14.62,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--screens-2--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4,148V198.3c0,1.65,1.16,2.33,2.6,1.5l116.78-67.43a5.76,5.76,0,0,0,2.6-4.5V77.53c0-1.65-1.17-2.33-2.6-1.5L91,143.46A5.73,5.73,0,0,0,88.4,148Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.53,147.21l35-20.2c1.61-.93,2.9-.18,2.9,1.67v35.17a6.37,6.37,0,0,1-2.9,5l-35,20.21c-1.6.92-2.9.17-2.9-1.68V152.23A6.4,6.4,0,0,1,96.53,147.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.87,144.56l-10.41,21.58-5.3-3.06a2.24,2.24,0,0,0-3,.82L93.63,185.51v1.89c0,1.85,1.3,2.6,2.9,1.68l35-20.21a6.4,6.4,0,0,0,2.9-5V151.5l-7-7.34A1.45,1.45,0,0,0,124.87,144.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.89,160.08a16.43,16.43,0,0,0,7.43-12.87c0-2.17-.7-3.74-1.85-4.58l-7.94,4.58a6.4,6.4,0,0,0-2.9,5v8.37C95,161.38,96.84,161.26,98.89,160.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.49,121.08l52.59-30.37c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.6l-52.59,30.36c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,147.49,121.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.49,131.47l52.59-30.37c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.6l-52.59,30.36c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,147.49,131.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.49,141.86l52.59-30.36c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-52.59,30.36c-1.2.7-2.17.21-2.17-1.09A4.64,4.64,0,0,1,147.49,141.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.49,152.25l52.59-30.36c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59L147.49,157c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,147.49,152.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,306.26V232.45a5.73,5.73,0,0,1,2.6-4.5l88.32-51c1.43-.83,2.6-.16,2.6,1.5v73.81a5.76,5.76,0,0,1-2.6,4.5l-88.32,51C65.16,308.59,64,307.92,64,306.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,302.57v3.69c0,1.66,1.16,2.33,2.6,1.5l88.32-51a5.76,5.76,0,0,0,2.6-4.5v-3.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.73,235.63l9-.47c1.1-.06,1.4.56.67,1.4l-10.34,11.76c-.73.83-1.32.6-1.32-.5V237.74A2.13,2.13,0,0,1,106.73,235.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,254.77a6.09,6.09,0,0,1-3.08-.79c-2.22-1.29-3.44-4-3.44-7.54,0-7.22,5.09-16,11.35-19.65,3.09-1.79,6-2.06,8.24-.78s3.45,4,3.45,7.53c0,7.23-5.1,16-11.35,19.65A10.49,10.49,0,0,1,104.41,254.77Zm10-28.87a9.8,9.8,0,0,0-4.82,1.49c-6.07,3.5-11,12.05-11,19.05,0,3.32,1.1,5.79,3.1,6.94s4.68.88,7.55-.78c6.07-3.51,11-12,11-19.06,0-3.32-1.1-5.78-3.1-6.94A5.5,5.5,0,0,0,114.4,225.9Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locator--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.87,163.86l-5.47-3.14h0c-2.61-1.75-6.24-1.68-10.25.64-8,4.6-14.42,16.27-14.42,26.07v2.23c0,9.8,13.18,20.44,13.18,20.44l5.38,3.05s-3.23-3.69-2.86-4.45C58,201.46,67.55,181,67.55,173v-2.23a17.33,17.33,0,0,0-.61-4.78l.61.35ZM53.14,186.33c-4,2.3-7.21.43-7.21-4.16,2.14-.34,7.53-9.54,7.21-12.49,4-2.3,7.2-.43,7.21,4.16A15.94,15.94,0,0,1,53.14,186.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.87,163.86l-5.47-3.14h0c-2.61-1.75-6.24-1.68-10.25.64-8,4.6-14.42,16.27-14.42,26.07v2.23c0,9.8,13.18,20.44,13.18,20.44l5.38,3.05s-3.23-3.69-2.86-4.45C58,201.46,67.55,181,67.55,173v-2.23a17.33,17.33,0,0,0-.61-4.78l.61.35ZM53.14,186.33c-4,2.3-7.21.43-7.21-4.16,2.14-.34,7.53-9.54,7.21-12.49,4-2.3,7.2-.43,7.21,4.16A15.94,15.94,0,0,1,53.14,186.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.87,163.86a1.18,1.18,0,0,0-.19-.11c-2.57-1.44-6-1.24-9.78.94-5.7,3.3-10.63,10.21-13,17.48v0a28.42,28.42,0,0,0-1.44,8.57V193c0,7.55,8.55,16.31,12.48,19.94a2.47,2.47,0,0,0,.27.21s0,0,0,0a1.94,1.94,0,0,0,2.76-.81c3.4-7,13.29-27.88,13.29-36v-2.23C73.32,169.07,71.61,165.51,68.87,163.86ZM51.82,186.94a8.06,8.06,0,0,1-.12-1.44A15.93,15.93,0,0,1,58.9,173a9,9,0,0,1,1.31-.62c3.36-1.22,5.9.71,5.9,4.78a15.91,15.91,0,0,1-7.21,12.48C55.37,191.7,52.43,190.46,51.82,186.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.11,177.17a15.91,15.91,0,0,1-7.21,12.48c-3.53,2-6.47.81-7.08-2.71a7.71,7.71,0,0,0,1.32-.61,15.93,15.93,0,0,0,7.2-12.49,7.38,7.38,0,0,0-.13-1.45C63.57,171.17,66.11,173.1,66.11,177.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.11,177.17a15.91,15.91,0,0,1-7.21,12.48c-3.53,2-6.47.81-7.08-2.71a7.71,7.71,0,0,0,1.32-.61,15.93,15.93,0,0,0,7.2-12.49,7.38,7.38,0,0,0-.13-1.45C63.57,171.17,66.11,173.1,66.11,177.17Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.18,301.33s3.61-23-4.41-42.78-18.83-21-24.43-18.19-2,13.78,3,21.15C152,271.18,163,292,162.64,310.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,301.33s3.61-23-4.41-42.78-18.83-21-24.43-18.19-2,13.78,3,21.15C152,271.18,163,292,162.64,310.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.58,302.79h0a.67.67,0,0,1-.65-.71c1.32-31.49-14.41-55-21.2-59.58a.68.68,0,1,1,.76-1.13c8,5.34,23.12,29.38,21.79,60.77A.67.67,0,0,1,167.58,302.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,328.64c-1.37-3.44-4.91-7.28-14-11.38s-15.93-9.57-17.19-13.53a5.91,5.91,0,0,1,1.61-6.31s-8.57-1-9.65-6.25c-1.35-6.62,6.14-7.05,6.14-7.05s-9.83-13.84-12.44-20,.4-6.53,6.74-4.18,18.42,14.18,20.29,17.79c0,0,3.27-4,6.79-1.37s3.69,10.5,1.61,13.34a7.38,7.38,0,0,1,7.43,3.07c3.58,4.69,4.76,16.42,4.76,16.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,325.44a.69.69,0,0,1-.66-.52c-4.86-20.25-27.93-52.57-42.26-62.85a.68.68,0,0,1,.79-1.11c14.51,10.41,37.87,43.14,42.8,63.64a.69.69,0,0,1-.51.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--screen-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.41,121.53a.72.72,0,0,1-.34-.09l-2.81-1.63a.68.68,0,1,1,.68-1.18l2.81,1.63a.68.68,0,0,1,.25.93A.68.68,0,0,1,351.41,121.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,180.82V329.6c0,1.66,1.16,2.33,2.59,1.5L345.89,230.91a5.76,5.76,0,0,0,2.6-4.5V77.63c0-1.66-1.17-2.33-2.6-1.5L172.35,176.32A5.74,5.74,0,0,0,169.76,180.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.07,208.3c0,5.19,3.87,7.15,8.66,4.39L336.3,133.26V114.5L198.73,193.92C193.94,196.69,190.07,203.12,190.07,208.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,107.77c4.78-2.76,8.66-.8,8.66,4.38s-3.88,11.62-8.66,14.38l-11.65,6.73V114.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8,123.58a2.76,2.76,0,0,1-1.42-.37,3.55,3.55,0,0,1-1.56-3.28,9.8,9.8,0,0,1,4.5-7.8,3.2,3.2,0,0,1,5.18,3,9.83,9.83,0,0,1-4.5,7.8A4.44,4.44,0,0,1,343.8,123.58Zm3.71-10.75a3.1,3.1,0,0,0-1.51.48,8.59,8.59,0,0,0-3.82,6.62,1.88,1.88,0,0,0,3.14,1.81,8.57,8.57,0,0,0,3.82-6.62,2.27,2.27,0,0,0-.88-2.1A1.44,1.44,0,0,0,347.51,112.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,148.83,217,225.57a5.71,5.71,0,0,0-2.6,4.5V271c0,1.66,1.16,2.33,2.6,1.5L350,195.73a5.73,5.73,0,0,0,2.6-4.5v-40.9C352.55,148.67,351.39,148,350,148.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,148.83,217,225.57a5.71,5.71,0,0,0-2.6,4.5V271c0,1.66,1.16,2.33,2.6,1.5L350,195.73a5.73,5.73,0,0,0,2.6-4.5v-40.9C352.55,148.67,351.39,148,350,148.83Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.35,204.48l24.1-13.92c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59l-24.1,13.92c-1.2.69-2.17.2-2.17-1.1A4.64,4.64,0,0,1,265.35,204.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,217.45c0,1.3,1,1.79,2.17,1.1l72.85-42.06a4.65,4.65,0,0,0,2.16-3.6c0-1.29-1-1.78-2.16-1.09l-72.85,42.06A4.64,4.64,0,0,0,263.18,217.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,226.83c0,1.3,1,1.79,2.17,1.1l72.85-42.06a4.65,4.65,0,0,0,2.16-3.6c0-1.29-1-1.78-2.16-1.09l-72.85,42.06A4.64,4.64,0,0,0,263.18,226.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,236.21c0,1.3,1,1.79,2.17,1.1l72.85-42.06a4.65,4.65,0,0,0,2.16-3.6c0-1.29-1-1.78-2.16-1.09l-72.85,42.06A4.64,4.64,0,0,0,263.18,236.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,227.91l31.36-18.11c1.44-.82,2.6-.15,2.6,1.5v31.53a5.74,5.74,0,0,1-2.6,4.5l-31.36,18.1c-1.43.83-2.6.16-2.6-1.49V232.41A5.73,5.73,0,0,1,221.1,227.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.5,225.54l-9.33,19.34-4.75-2.74a2,2,0,0,0-2.73.73L218.5,262.24v1.69c0,1.66,1.17,2.33,2.6,1.5l31.36-18.1a5.73,5.73,0,0,0,2.6-4.5V231.76l-6.31-6.58A1.3,1.3,0,0,0,246.5,225.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.21,239.45a14.73,14.73,0,0,0,6.66-11.54,4.89,4.89,0,0,0-1.66-4.11l-7.11,4.11a5.73,5.73,0,0,0-2.6,4.5v7.5C219.71,240.61,221.37,240.51,223.21,239.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,209.8,217,286.54a5.73,5.73,0,0,0-2.6,4.5V332c0,1.65,1.16,2.32,2.6,1.5L350,256.71a5.73,5.73,0,0,0,2.6-4.5V211.3C352.55,209.65,351.39,209,350,209.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,209.8,217,286.54a5.73,5.73,0,0,0-2.6,4.5V332c0,1.65,1.16,2.32,2.6,1.5L350,256.71a5.73,5.73,0,0,0,2.6-4.5V211.3C352.55,209.65,351.39,209,350,209.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.35,265.45l24.1-13.91c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-24.1,13.91c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,265.35,265.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,278.43c0,1.29,1,1.78,2.17,1.09l72.85-42.06a4.65,4.65,0,0,0,2.16-3.59c0-1.3-1-1.79-2.16-1.1l-72.85,42.06A4.64,4.64,0,0,0,263.18,278.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,287.81c0,1.29,1,1.78,2.17,1.09l72.85-42.06a4.65,4.65,0,0,0,2.16-3.59c0-1.3-1-1.79-2.16-1.1l-72.85,42.06A4.64,4.64,0,0,0,263.18,287.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,297.19c0,1.29,1,1.78,2.17,1.09l72.85-42.06a4.65,4.65,0,0,0,2.16-3.59c0-1.3-1-1.79-2.16-1.1l-72.85,42.06A4.64,4.64,0,0,0,263.18,297.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,288.89l31.36-18.11c1.44-.83,2.6-.16,2.6,1.5V303.8a5.71,5.71,0,0,1-2.6,4.5L221.1,326.41c-1.43.83-2.6.16-2.6-1.5V293.39A5.73,5.73,0,0,1,221.1,288.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.5,286.52l-9.33,19.34-4.75-2.75a2,2,0,0,0-2.73.74L218.5,323.22v1.69c0,1.66,1.17,2.33,2.6,1.5l31.36-18.11a5.71,5.71,0,0,0,2.6-4.49V292.73l-6.31-6.57A1.29,1.29,0,0,0,246.5,286.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.21,300.42a14.71,14.71,0,0,0,6.66-11.53,4.89,4.89,0,0,0-1.66-4.11l-7.11,4.11a5.73,5.73,0,0,0-2.6,4.5v7.5C219.71,301.58,221.37,301.48,223.21,300.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.49,84V77.63c0-1.66-1.17-2.33-2.6-1.5L172.36,176.32a5.73,5.73,0,0,0-2.6,4.5v6.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,89.36a4.27,4.27,0,0,0-1.92,3.34c0,1.23.86,1.73,1.92,1.11a4.22,4.22,0,0,0,1.93-3.33C329.13,89.25,328.27,88.75,327.2,89.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.85,85a4.27,4.27,0,0,0-1.93,3.34c0,1.23.87,1.72,1.93,1.11a4.24,4.24,0,0,0,1.93-3.34C336.78,84.83,335.92,84.34,334.85,85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,80.54a4.22,4.22,0,0,0-1.93,3.33c0,1.23.86,1.73,1.93,1.12a4.27,4.27,0,0,0,1.92-3.34C344.42,80.42,343.56,79.92,342.5,80.54Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.26,394.22a10.22,10.22,0,0,1,.62,2.39,5.35,5.35,0,0,1,.19,2.63,5.22,5.22,0,0,1-3,2.32,6.6,6.6,0,0,1-5.23-1c-1.83-1.09-3.2-2.42-5.8-3.15a13.19,13.19,0,0,1-5.12-2.33c-1.44-1.15-3.36-4.35-.61-5.09s8.74,1.87,14.19,2.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,390.62s.32,3.82.32,4.29c0,1.29-4.76,3-5.64,0l-.76-4.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.16,306.81a77.08,77.08,0,0,1,4.49,7.48s.47,5.56.47,9.26c0,6.8-1.05,12.05-2,25.45a18.92,18.92,0,0,1,2.58,8.66c.4,6.07.41,6,.45,34a7.77,7.77,0,0,1-6,.58l-9-39.21-1-15.39-2.82-19.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.86,401.23c.32.33.21,1,.36,2.1a9,9,0,0,1,.13,2.57,5.24,5.24,0,0,1-2.66,2.67,6.66,6.66,0,0,1-5.32-.35c-1.94-.86-3.47-2-6.14-2.41a13.14,13.14,0,0,1-5.37-1.67c-1.57-1-3.88-3.9-1.24-5s9.26.87,14.69.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,396.43s-1,4.36-1.27,5.33c-.6,2.33-5.77,2.45-5.77-.24l.35-6.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.49,308c2.59,5.09,5.09,9.58,5.17,15,.19,11.47-4.57,24.1-6.32,32.39a36.88,36.88,0,0,1,.44,9.09c-.35,3.47-8.26,35-8.26,35s-4.4.92-6.27-1.07l2.22-60.71.6-17.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.93 276.91 331.56 285.94 339.72 285.34 338.01 275.11 329.93 276.91",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,284.68c-.81-2.45-3.92-5.12-7-4.54a92.66,92.66,0,0,0-13.64,3.4c-2.85,1-5.45,3.49-5.69,12.87l-.89,23.6a10.25,10.25,0,0,0,4.31,2.28c4.33,1.19,7.19,1.9,13.77.46,8.57-1.87,10.61-7.06,10.61-7.06s-.33-12.49-.59-19.28C349,290.64,348.88,286.37,348.33,284.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.45,265.38,284.9,254.11c-3.76-.65-5.33,8.53-1.57,9.17L326,267.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,284.42l-8.49.26s1.28-12.63,2.07-14.29,2.68-2,4.56-2.53,1.87-1.43,1.87-1.43l-1.69-.17c-1.48-.15-2.07-2-1.43-3.25.31-.58.81-1.5,1.71-1.25l2.24.61a5.23,5.23,0,0,0-.71-2.82c-.75-.83-1.25-.57-2.75-1.09-1.11-.39-3.38-1.08-5.21-.33s-3.22,4.19-3.69,6.62a40.49,40.49,0,0,1-2.3,8.21c-1.63,4.5-4,13.74-4.25,17.44-.11,1.71.05,2.73,1.95,3.18s15.88.48,15.88.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.89,266.22s-2,2.92-1.72,3.24a4.66,4.66,0,0,0,1.48.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.92,257c-1.9,1-5.18,2.73-6.09,9.69-.93,7.14.3,9.44,1.26,10.39.66.64,4.2.68,6,.14,2.22-.66,7.23-2.57,9.52-6.24,2.69-4.32,3.29-10.1.26-12.4A11.42,11.42,0,0,0,329.92,257Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.51,343.17l4.33-12.24a21.44,21.44,0,0,0,8.75-5.84s-1,3.49-7.84,7.07L336,343.74l0,6.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.44,259.35c.62,1.71,1.67,5.91,6.05,7.66,0,0,.63-2.67,2.87-2.39s2.63,3.15,1.25,4.93-2.72,1.14-2.72,1.14-.3,3.83,2.26,5.57a7.15,7.15,0,0,0,6.36.45c1.47-.67,3.56-4.2,4.78-7.1,2.58-6.12,2.95-11-1-12.58-.49-2.78-1.74-3.83-4.26-4.35-5.42-1.11-9.52,2.45-14.07,1.82C322.63,254.17,322.72,257.39,323.44,259.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.42,258l2.56-1.59a1.51,1.51,0,0,0-2.56,1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.6,284.25s11.95-.69,15-.71,6.29,5.19,4.39,8.74c-1.26,2.33-5.19,3.13-10.14,3.37s-9.94.24-9.94.24S307.46,290.82,312.6,284.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,295.65s7.57-.1,10.05-3.37c0,0-.58,2-3.52,3.23a21.89,21.89,0,0,1-6.58,1.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.9,254.11c-3.76-.65-5.33,8.53-1.57,9.17l6,.6c-2.44-.25-.75-8.78,1.11-8.28h0Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifiyng-glass--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.22,251.66a9.26,9.26,0,0,1-16.05,6.3l-.61-.74,0,0a9.26,9.26,0,0,1,14.2-11.85l.63.76h0A9.28,9.28,0,0,1,436.22,251.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,251.66a9.26,9.26,0,0,1-16.05,6.3l-.61-.74,0,0L381,210.65l16.25-9.38,36.51,44.08.63.76h0A9.28,9.28,0,0,1,436.22,251.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.32,238.81A9.26,9.26,0,0,0,418.53,227h0l-4.77-5.75h0a9.26,9.26,0,0,1-14.21,11.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,128.06a21.5,21.5,0,0,1,8.27,2.69l-11.73-6.82h0c-7.87-5.41-19.2-5.09-31.79,2.17-23.77,13.73-43.05,47.12-43.05,74.58,0,13.49,4.59,23.13,12.16,27.71l.16.1,12.52,7.21a21.6,21.6,0,0,1-5.71-5.43,27.91,27.91,0,0,0,9.23-.53c1.1-.24,2.21-.53,3.34-.89a2.75,2.75,0,0,1-.43-.17,11.23,11.23,0,0,1-1.72-1,12.05,12.05,0,0,1-2.6-2.46,17.31,17.31,0,0,1-2.44-4.25,17.49,17.49,0,0,1-2.46.18,13.4,13.4,0,0,1-5.66-1.13,10.81,10.81,0,0,1-1.21-.65c-.35-.22-.7-.48-1-.74a47.62,47.62,0,0,1-1.05-10.3c0-27.45,19.28-60.85,43.07-74.58a49.26,49.26,0,0,1,9.6-4.3,10.86,10.86,0,0,1,2.52,1.45,12.42,12.42,0,0,1,2.19,2.16,17.4,17.4,0,0,1,2.45,4.26,17.59,17.59,0,0,1,2.47-.17,12.75,12.75,0,0,1,6.48,1.57,10.37,10.37,0,0,1,1.43.94c-.18-.8-.37-1.59-.6-2.34A28.32,28.32,0,0,0,396.63,128.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.9,130.75l-.68-.37a21.48,21.48,0,0,0-7.59-2.32,27.35,27.35,0,0,0-8.53.39,35.76,35.76,0,0,0-4,1,49.26,49.26,0,0,0-9.6,4.3c-23.79,13.73-43.07,47.13-43.07,74.58a47.62,47.62,0,0,0,1.05,10.3c.13.61.28,1.19.43,1.77a29.2,29.2,0,0,0,4.56,9.85,21.77,21.77,0,0,0,3.25,3.57,20.89,20.89,0,0,0,2.46,1.86c7.85,5.07,19,4.63,31.3-2.49,23.79-13.73,43.07-47.12,43.07-74.58C417.54,144.88,412.71,135.23,404.9,130.75Zm-4.7,8a10.37,10.37,0,0,1,1.43.94,13.77,13.77,0,0,1,2.05,2.06c3,3.76,4.59,9.61,4.59,16.89,0,24-17.6,54.52-38.43,66.55-5.25,3-10.3,4.64-14.59,4.64a13.31,13.31,0,0,1-5.22-1,2.75,2.75,0,0,1-.43-.17,11.23,11.23,0,0,1-1.72-1,11.81,11.81,0,0,1-1.86-1.62h0c-.25-.26-.49-.55-.73-.84a17.31,17.31,0,0,1-2.44-4.25,33.38,33.38,0,0,1-2.14-12.64c0-.32,0-.63,0-1,.44-23.9,17.85-53.73,38.41-65.59.47-.27.95-.54,1.43-.79a31.79,31.79,0,0,1,10.69-3.67,17.59,17.59,0,0,1,2.47-.17,13.37,13.37,0,0,1,5.19,1A8.51,8.51,0,0,1,400.2,138.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.27,158.63c0,24-17.6,54.52-38.43,66.55a41.23,41.23,0,0,1-3.9,2,0,0,0,0,1,0,0,26.51,26.51,0,0,1-10.66,2.62,13.31,13.31,0,0,1-5.22-1,2.75,2.75,0,0,1-.43-.17,11.23,11.23,0,0,1-1.72-1,12.05,12.05,0,0,1-2.6-2.46c-.26-.35-.53-.69-.77-1.08.47,0,1,.07,1.46.07,4.29,0,9.34-1.61,14.59-4.64C381.39,207.56,399,177.08,399,153c0-6.61-1.31-12-3.8-15.79a11.74,11.74,0,0,1,5,1.49,10.37,10.37,0,0,1,1.43.94,13.77,13.77,0,0,1,2.05,2.06c2.64,3.31,4.19,8.23,4.51,14.32C408.24,156.9,408.27,157.76,408.27,158.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.25,155.86c0,24-17.6,54.52-38.43,66.55-5.25,3-10.29,4.64-14.59,4.64a13.26,13.26,0,0,1-5.21-1h0c-.25-.26-.49-.55-.73-.84a17.31,17.31,0,0,1-2.44-4.25,33.38,33.38,0,0,1-2.14-12.64c0-.32,0-.63,0-1,.44-23.9,17.85-53.73,38.41-65.59.47-.27.95-.54,1.43-.79a31.79,31.79,0,0,1,10.69-3.67,17.59,17.59,0,0,1,2.47-.17,13.37,13.37,0,0,1,5.19,1c.27.27.52.56.76.85C402.66,142.73,404.25,148.58,404.25,155.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAmico);
export default __webpack_public_path__ + "static/media/Search-amico.4a34db8b596f4e72121162778240ad0a.svg";
export { ForwardRef as ReactComponent };